import React from "react";
import { Helmet } from "react-helmet";

import PayDelivery from "./PayDelivery/PayDelivery";

export default function PayDeliveryPage() {
  return (
    <div className="home">
      <Helmet>
        <title>Trippie Air - How to Pay for Delivery</title>
        <meta
          name="description"
          content="Learn how to pay for your Trippie Air delivery using your credit or debit card"
        />
      </Helmet>
      <div className="container-middle-content">
        <div className="how-to-container">
          <PayDelivery />
        </div>
      </div>
    </div>
  );
}
